import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { IndexComponent } from './pages/index/index.component';
import { SectionsIndexComponent } from './pages/sections-index/sections.component';
import { ModuleIndexComponent } from './pages/module-index/module-index.component';
import { ElectiveComponent } from './pages/elective-overview/elective.component';
import { LessonDetailsComponent } from './pages/lesson-details/lesson-details.component';
import { LessonOverviewComponent } from './pages/lesson-overview/lesson-overview.component';
import { ProfileComponent } from './pages/profile/profile.component';

import { PasswordResetComponent } from './pages/password-reset/password-reset.component';
import { PasswordRecoveryComponent } from './pages/password-recovery/password-recovery.component';

import { PagesComponent } from './pages/pages/pages.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { EntreeComponent } from './pages/entree/entree.component';
import { DebugComponent } from './pages/debug/debug.component';
import { environment } from 'src/environments/environment';

import { ActivateAccountComponent } from './pages/activate-account/activate-account.component';

const routes: Routes = [
  { path: '', redirectTo: '/index', pathMatch: 'full' },
  { path: 'index', component: getIndexComponent() },
  { path: 'elective/:id', component: ElectiveComponent },
  { path: 'debug', component: DebugComponent },
  { path: 'profielpagina', component: ProfileComponent },
  { path: 'wachtwoord-instellen/:hash/:email', component: PasswordResetComponent },
  { path: 'wachtwoord-vergeten/:email', component: PasswordRecoveryComponent },
  { path: 'wachtwoord-vergeten', component: PasswordRecoveryComponent },

  { path: 'activeren/:email', component: ActivateAccountComponent },
  { path: 'activeren', component: ActivateAccountComponent },

  { path: 'wachtwoord-aanvragen/:email', component: PasswordRecoveryComponent },
  { path: 'wachtwoord-aanvragen', component: PasswordRecoveryComponent },
  { path: 'keuzeopdrachten', component: LessonOverviewComponent },
  { path: 'burgerschapskaarten', component: LessonOverviewComponent },
  { path: 'preview/:previewId', component: LessonDetailsComponent, pathMatch: 'full' },
  { path: 'les/:id', component: LessonDetailsComponent, pathMatch: 'full' },
  { path: 'module/:id', component: LessonOverviewComponent, pathMatch: 'full' },
  { path: 'vak/:id', component: LessonOverviewComponent, pathMatch: 'full' },
  { path: 'les/:id/:studentId', component: LessonDetailsComponent, pathMatch: 'full' },
  { path: 'info/:id', component: PagesComponent, pathMatch: 'full' },
  { path: 'wp-admin/admin-ajax.php', component: EntreeComponent, pathMatch: 'full' },
  { path: 'entree', component: EntreeComponent, pathMatch: 'full' },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

function getIndexComponent() {
  if (environment.frontStyle == "sections") {
    return SectionsIndexComponent;
  } else if (environment.frontStyle == "method") {
    return ModuleIndexComponent;
  } else {
    return IndexComponent;
  }
}